const wrap = (body: string, viewBox = "0 0 24 24"): string =>
  `<svg class="icon" viewBox="${viewBox}" aria-hidden="true" focusable="false">${body}</svg>`;

export const icons = {
  home: wrap('<path d="M3 10.5 12 3l9 7.5"/><path d="M5.5 9.5V21h13V9.5"/>'),
  search: wrap('<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>'),
  library: wrap('<rect x="3.5" y="4.5" width="17" height="15" rx="2.5"/><path d="M3.5 9.5h17"/>'),
  settings: wrap(
    '<circle cx="12" cy="12" r="3.2"/><path d="M12 3v2.2M12 18.8V21M4.2 7.5l1.9 1.1M17.9 15.4l1.9 1.1M4.2 16.5l1.9-1.1M17.9 8.6l1.9-1.1"/>',
  ),
  play: wrap('<path d="M8 5.5v13l11-6.5z"/>'),
  pause: wrap('<path d="M8 5h3v14H8zM13 5h3v14h-3z"/>'),
  volume: wrap(
    '<path d="M4 9.5h3.5L12 5.5v13L7.5 14.5H4z"/><path d="M15.5 9a4.5 4.5 0 0 1 0 6"/><path d="M18 6.5a8 8 0 0 1 0 11"/>',
  ),
  mute: wrap('<path d="M4 9.5h3.5L12 5.5v13L7.5 14.5H4z"/><path d="m16 9.5 5 5M21 9.5l-5 5"/>'),
  fullscreen: wrap('<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>'),
  pip: wrap('<rect x="3" y="5" width="18" height="14" rx="2"/><rect x="12" y="11" width="7" height="5" rx="1"/>'),
  heart: wrap(
    '<path d="M12 20s-7.2-4.4-9.1-8.3C1.5 8.4 3.6 5.5 6.9 5.5c2 0 3.6 1.1 5.1 3 1.5-1.9 3.1-3 5.1-3 3.3 0 5.4 2.9 4 6.2C19.2 15.6 12 20 12 20z"/>',
  ),
  plus: wrap('<path d="M12 5v14M5 12h14"/>'),
  check: wrap('<path d="m5 12.5 4.5 4.5L19 7.5"/>'),
  back: wrap('<path d="M15 5 8 12l7 7"/>'),
  chevron: wrap('<path d="m9 5 7 7-7 7"/>'),
  close: wrap('<path d="m6 6 12 12M18 6 6 18"/>'),
  menu: wrap('<path d="M3 6h18M3 12h18M3 18h18"/>'),
  grid: wrap(
    '<rect x="3.5" y="3.5" width="7" height="7" rx="1"/><rect x="13.5" y="3.5" width="7" height="7" rx="1"/><rect x="3.5" y="13.5" width="7" height="7" rx="1"/><rect x="13.5" y="13.5" width="7" height="7" rx="1"/>',
  ),
  sun: wrap(
    '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2.2M12 19.3v2.2M4.2 4.2l1.6 1.6M18.2 18.2l1.6 1.6M2.5 12h2.2M19.3 12h2.2M4.2 19.8l1.6-1.6M18.2 5.8l1.6-1.6"/>',
  ),
  moon: wrap('<path d="M20 13.4A8.1 8.1 0 0 1 10.6 4a8.1 8.1 0 1 0 9.4 9.4z"/>'),
  density: wrap(
    '<rect x="3.5" y="4.5" width="10" height="6" rx="1"/><rect x="16" y="4.5" width="4.5" height="6" rx="1"/><rect x="3.5" y="13.5" width="6" height="6" rx="1"/><rect x="12" y="13.5" width="8.5" height="6" rx="1"/>',
  ),
  chevronDown: wrap('<path d="m5 9 7 7 7-7"/>'),
  more: wrap('<path d="M5 12h14M5 6h14M5 18h9"/>'),
  back10: wrap(
    '<path d="M13.4 4.8a8 8 0 1 0 6.8 5.3"/><path d="M13.4 2.4v4.7H8.7"/><path d="m9.8 10.6 1.4-.9v5.1"/><path d="M15.4 9.7a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5z"/>',
  ),
  forward10: wrap(
    '<path d="M10.6 4.8a8 8 0 1 1-6.8 5.3"/><path d="M10.6 2.4v4.7h4.7"/><path d="m8.9 10.6 1.4-.9v5.1"/><path d="M14.5 9.7a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5z"/>',
  ),
  speed: wrap(
    '<path d="M4 16.5a8 8 0 1 1 16 0"/><path d="m12 16.5 3.9-5.1"/><circle cx="12" cy="16.5" r="1.4"/>',
  ),
  quality: wrap(
    '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M7 15V9h2.4a2 2 0 0 1 0 4H7M13.2 9h1.9a3 3 0 0 1 0 6h-1.9z"/>',
  ),
  fullscreenExit: wrap('<path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5"/>'),
  next: wrap('<path d="M6 5.5 15.5 12 6 18.5z"/><path d="M18 5v14"/>'),
  previous: wrap('<path d="M18 5.5 8.5 12 18 18.5z"/><path d="M6 5v14"/>'),
  retry: wrap('<path d="M20 12a8 8 0 1 1-2.4-5.7"/><path d="M20 4v5h-5"/>'),
  captions: wrap(
    '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M10.4 10.2a2.4 2.4 0 1 0 0 3.6M17.4 10.2a2.4 2.4 0 1 0 0 3.6"/>',
  ),
} as const;
